var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhoneIcon = function SvgPhoneIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1989_1",
    "data-name": "Component 1989 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.732,
    height: 20.816,
    viewBox: "0 0 12.732 20.816",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M402.927,253.2l-.527.192a16.754,16.754,0,0,1-2.5-3.919,14.061,14.061,0,0,1-.883-4.539l.385-.16-2.341-5.6a4.588,4.588,0,0,0-1.137,1.289c-1.326,2.239-1.194,5.676.14,9.033s2.758,6.352,5.358,8.235a5.139,5.139,0,0,0,3.871,1.144Z",
    transform: "translate(-394.998 -238.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M405.971,254.576l-.727.264,2.4,5.738a4.284,4.284,0,0,0,.724-.313,1.4,1.4,0,0,0,.63-1.739l-1.252-3.155A1.394,1.394,0,0,0,405.971,254.576Z",
    transform: "translate(-396.361 -240.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M399.35,238.021a5.541,5.541,0,0,0-.939.441l2.391,5.723.805-.336a1.393,1.393,0,0,0,.761-1.792l-1.257-3.227A1.39,1.39,0,0,0,399.35,238.021Z",
    transform: "translate(-395.452 -237.939)",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone-icon.910e5b8414b9bafa80826a0de6b899af.svg";